"use strict";

var _defineProperty = require("/codebuild/output/src1656618240/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/codebuild/output/src1656618240/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var React = _interopRequireWildcard(require("react"));

var _configProvider = require("../config-provider");

var _context = require("../form/context");

var _style = _interopRequireDefault(require("./style"));

var Group = function Group(props) {
  var _ref4;

  var _ref = (0, React.useContext)(_configProvider.ConfigContext),
      getPrefixCls = _ref.getPrefixCls,
      direction = _ref.direction;

  var customizePrefixCls = props.prefixCls,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className;
  var prefixCls = getPrefixCls('input-group', customizePrefixCls);
  var inputPrefixCls = getPrefixCls('input');

  var _ref2 = (0, _style.default)(inputPrefixCls),
      _ref3 = _slicedToArray(_ref2, 2),
      wrapSSR = _ref3[0],
      hashId = _ref3[1];

  var cls = (0, _classnames.default)(prefixCls, (_ref4 = {}, _defineProperty(_ref4, "".concat(prefixCls, "-lg"), props.size === 'large'), _defineProperty(_ref4, "".concat(prefixCls, "-sm"), props.size === 'small'), _defineProperty(_ref4, "".concat(prefixCls, "-compact"), props.compact), _defineProperty(_ref4, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _ref4), hashId, className);
  var formItemContext = (0, React.useContext)(_context.FormItemInputContext);
  var groupFormItemContext = (0, React.useMemo)(function () {
    return Object.assign(Object.assign({}, formItemContext), {
      isFormItemInput: false
    });
  }, [formItemContext]);
  return wrapSSR( /*#__PURE__*/React.createElement("span", {
    className: cls,
    style: props.style,
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    onFocus: props.onFocus,
    onBlur: props.onBlur
  }, /*#__PURE__*/React.createElement(_context.FormItemInputContext.Provider, {
    value: groupFormItemContext
  }, props.children)));
};

var _default = Group;
exports.default = _default;